<template>
  <div class="w-full h-full">
    <h2
      class="w-full lg:w-3/4 mx-auto my-4 px-8 font-medium text-2xl document-page-title"
    >
      {{ $t('message.documentsManagement.title') }}
    </h2>
    <div class="flex flex-col lg:flex-row w-full lg:w-3/4 m-auto px-8">
      <div
        data-vs-button="card-goto"
        v-for="(card, index) in filterMainMenu"
        :key="index"
        @click="redirectTo(card.to)"
        class="w-full lg:w-1/2 lg:mr-4 mb-4 lg:mb-0"
      >
        <div
          class="bg-white flex rounded items-center shadow-md hover:shadow-lg cursor-pointer p-4"
        >
          <div class="w-4/12 full-svg">
            <component :is="card.img"></component>
          </div>
          <div class="w-8/12 pl-2">
            <p class="font-medium text-xl mb-3 text-zt-dark-600 porlet-title">
              {{ card.title }}
            </p>
            <span class="text-zt-dark-300">{{ card.subtitle }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-3/4 m-auto mt-10 px-8" v-if="isHistoryAllowed">
      <div>
        <div class="mb-4">
          <h3>{{ $t('message.documentsManagement.cards.history.title') }}</h3>
        </div>
        <div class="w-full lg:w-1/3">
          <div
              class="bg-white flex rounded justify-start shadow-md hover:shadow-lg cursor-pointer p-8"
              @click="$router.push({ name: 'documentRequestHistory' })"
              data-vs-link="go-to-request-history"
          >
            <div class="mr-4">
              <zt-icon
                  name="search-outline"
                  :style="{ fontSize: '2rem'}"
              />
            </div>
            <div class="flex-grow">
              <p class="font-medium text-xl mb-2 text-zt-dark-600 porlet-title">
                {{ $t('message.documentsManagement.cards.history.subtitle') }}
              </p>
              <span class="text-zt-dark-300">
                {{ $t('message.documentsManagement.cards.history.description') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DocumentUploadSVG from '@/modules/Documents/components/SVG/DocumentUploadSVG'
import DocumentDownloadSVG from '@/modules/Documents/components/SVG/DocumentDownloadSVG'

export default {
  name: 'DocumentsManagementPage',
  components: {
    DocumentUploadSVG,
    DocumentDownloadSVG
  },
  data() {
    return {
      mainMenu: [
        {
          img: 'DocumentUploadSVG',
          title: this.$t('message.documentsManagement.cards.upload.title'),
          subtitle: this.$t(
            'message.documentsManagement.cards.upload.subtitle'
          ),
          action: 77,
          to: 'upload'
        },
        {
          img: 'DocumentDownloadSVG',
          title: this.$t(
            'message.documentsManagement.cards.certificates.title'
          ),
          subtitle: this.$t(
            'message.documentsManagement.cards.certificates.subtitle'
          ),
          action: 205,
          to: 'certificates'
        }
      ]
    }
  },
  computed: {
    ...mapState(['actions']),
    filterMainMenu() {
      return this.mainMenu.filter(this.filterActionsMenu)
    },
    isHistoryAllowed() {
      return this.actions.some(action => action.id === "301")
    }
  },
  methods: {
    filterActionsMenu(item) {
      if (!this.actions) return false
      if (this.actions.length > 0) {
        return this.actions.map(e => parseInt(e.id)).includes(item.action)
      }
      return false
    },
    redirectTo(to) {
      this.$router.push({ name: to })
    }
  }
}
</script>

<style scoped lang="scss">
h2, h3 {
  color: #707070;
}
h3 {
  font-size: 1.25rem;
}
.full-svg {
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
